import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AddInvoicesByAdmin from "./addInvoicesByAdmin";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Pagination } from "react-bootstrap";
import { format, parse } from "date-fns";
import InvoiceTransactionsHistory from "./invoiceTransactionsHistory";
import { FiInfo } from "react-icons/fi";

function LabIncomingInvoices({labcode}) {
  const [invoices, setInvoices] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedLab, setSelectedLab] = useState(null);
  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;
useEffect(() => {
           if (searchTerm || selectedLab || invoiceNumberFilter || selectedDate || statusFilter !== "all") {
             setCurrentPage(0); // Reset page before fetching new search data
           }
         }, [searchTerm, selectedLab, invoiceNumberFilter, selectedDate, statusFilter]);
         
         useEffect(() => {
           if (searchTerm || selectedLab || invoiceNumberFilter || selectedDate || statusFilter !== "all") {
             searchData(currentPage); // Fetch new search data with updated page number
           } else {
             getData(currentPage);
           }
         }, [searchTerm, selectedLab, invoiceNumberFilter, selectedDate, statusFilter, currentPage]);
         
  
    const searchData = async (page = 0) => {
      setLoader(true);
      try {
        const searchUrl = `/api/invoiceSearch/searchLabOrCompanyInvoices?page=${page}`;
        const requestData = {
          invoiceNumber: invoiceNumberFilter || null,
          date: selectedDate || null,
          labId: selectedLab || null,
          status: statusFilter === "all" ? null : statusFilter,
          invoicesFor:"Lab",
          invoiceType:"incoming"
        };
  
        const response = await axios.post(searchUrl, requestData, {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        setInvoices(response.data.content);
        setCurrentPage(response.data.number);
        setTotalPages(response.data.totalPages);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };
 

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const labRes = await axios.get(`/api/labdetails/labcode=${labcode}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              setSelectedLab(labRes.data?.id);
      const trans = await axios.get(`/api/invoices/getLabIncomingInvoices/labId=${labRes.data?.id}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setInvoices(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    const [isInvoiceTransactionModalOpen, setIsInvoiceTransactionModalOpen] = useState(false);
const handleOpenTransactionHistory = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setIsInvoiceTransactionModalOpen(true);
  };
  const handleCloseInvoiceTransactionModal = () => {
    setIsInvoiceTransactionModalOpen(false);
    setSelectedInvoiceId(null);
    searchData(0);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }
  
    const handleSearchInvoiceNumber = (event) => {
      setInvoiceNumberFilter(event.target.value.toLowerCase());
    };
  
    const handleDateChange = (date) => {
      if (date) {
        const formattedDate = format(date, "MM/yyyy");
        setSelectedDate(formattedDate); 
      } else {
        setSelectedDate(null);
      }
    };
  
    const handleStatusFilterChange = (e) => {
      setStatusFilter(e.target.value);
    };
  
  
  const handleViewPdf = async (id) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    await axios({
      url: `/api/invoices/download/id=${id}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      console.log("filedata;", response);
      const contentType = response.headers["content-type"];
      let extension = "";
  
      // Determine the file extension based on content type
      if (contentType.includes("application/pdf")) {
        extension = "pdf";
      } else if (contentType.includes("image/jpeg")) {
        extension = "jpg";
      } else if (contentType.includes("image/png")) {
        extension = "png";
      } else {
        console.error("Unsupported file type:", contentType);
        return;
      }
  
      // Create a blob URL and download link for the file
      const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `file.${extension}`);
      document.body.appendChild(link);
      link.click();
  
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  }

  const [loading, setLoading] = useState(null);

  function rsubmit(e, id, status) {
    e.preventDefault();
    setLoading(id);
  
    const token = JSON.parse(localStorage.getItem("data")).token;
  
    const entitiesToUpdate = ({
      id: id,
      status: status,
    });
  
    axios
      .post(
        "/api/invoices/update",
        entitiesToUpdate,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        setLoading(null);
        getData();
      })
      .catch((error) => {
       handleError(error);
      });
  }

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };


  return (
    <div>
        <div className="col-12 mx-xl-auto">
          <br />
          <div className="card card-raised">
            <div className="card-body">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                <span>Lab Incoming Invoices :</span>
                {/* <div>
                  <button className="btn btn-primary" onClick={handleCreateCompany}>
                    ADD
                  </button>
                </div> */}
              </div>

              <br />
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label htmlFor="invoiceNumberFilter" className="form-label">
                    Search by Invoice Number:
                  </label>
                  <input
                    type="search"
                    className="form-control"
                    id="invoiceNumberFilter"
                    placeholder="Search by Invoice Number"
                    value={invoiceNumberFilter || null}
                    onChange={handleSearchInvoiceNumber}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="monthYearFilter" className="form-label">
                    Filter by Month and Year:
                  </label>
                  <DatePicker
  selected={selectedDate ? parse(selectedDate, "MM/yyyy", new Date()) : null}
  onChange={handleDateChange}
  showMonthYearPicker
  dateFormat="MM/yyyy"
  className="form-select"
  placeholderText="Select Month and Year"
/>

                </div>

                <div className="col-md-3 mb-3">
                  <label htmlFor="statusFilter" className="form-label">
                    Filter by Status:
                  </label>
                  <select
                    id="statusFilter"
                    className="form-select"
                    value={statusFilter || "all"}
                    onChange={handleStatusFilterChange}
                  >
                    <option value="all">ALL</option>
                    <option value="Invoice Generated">INVOICE GENERATED</option>
                    <option value="Partial Payment">PARTIAL PAYMENT</option>
                    <option value="Paid">PAID</option>
                  </select>
                </div>
  
              </div>
  
                <br />
                <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                      <th>Date</th>
                      <th>Period</th>
                      <th>Invoice Number</th>
                      <th>Gross Amount</th>
                      <th>Tax</th>
                      <th>Net Pay</th>
                      <th>File</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No Data Available
                        </td>
                      </tr>
                    ) : (
                      invoices.map((invoice) => (
                        <tr key={invoice.id}>
                          <td>{invoice.date} </td>
                          <td>{invoice.startdate} to {invoice.enddate}</td>
                          <td>{invoice.invoicenumber}</td>
                          <td>{invoice.grossamount}</td>
                          <td>{invoice.tax}</td>
                          <td>{invoice.netpay}</td>
                          <td>
                      {invoice.invoiceFileUploaded===true ? (
                          <button
                            className="btn btn-primary"
                            onClick={() => handleViewPdf(invoice.id)}
                          >
                            View
                          </button>
                        ) : (
                          "No File Added"
                        )}
                        </td>
                        <td>
                          <div style={{ display: "flex", alignItems: "center" }}>
  {invoice.invoiceStatus?.status}
  {invoice.invoiceStatus?.status === "Paid" && (
    <FiInfo
      onClick={() => handleOpenTransactionHistory(invoice.id)}
      style={{
        cursor: "pointer",
        marginLeft: "8px", // Adjust spacing as needed
      }}
    />
  )}
  </div>
<br/>
{invoice.invoiceStatus?.status === "Partial Payment" && (
  <>
    <div style={{ color: "green", fontWeight: "bold" }}>
        Paid : ₹{invoice.paidAmount}
      </div>

      <div style={{ color: "red", fontWeight: "bold" }}>
        Pending: ₹{invoice.pendingAmount}
      </div>
  </>
)}

</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
  
       
              <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>

              {/* <div>
                {isModalOpen && <AddInvoicesByAdmin isOpen={isModalOpen} onRequestClose={handleCloseModal} />}
              </div> */}
            </div>
          </div>
        </div>
        {isInvoiceTransactionModalOpen && (
                    <InvoiceTransactionsHistory isOpen={isInvoiceTransactionModalOpen} onRequestClose={handleCloseInvoiceTransactionModal} invoiceId={selectedInvoiceId}/>
                  )}

      {loader && <div className="loading"></div>}
    </div>
  );
}

export default LabIncomingInvoices;
